export default __webpack_public_path__ + "static/media/chevron-up.3684d1bd.svg";